module.exports = __webpack_public_path__ + "img/send.5c17b4bb.svg";